import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PartnerProfileService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getPartnerProfile(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPartnerProfile/GetPartnerProfile', data, messageService);
    }

    public updatePartnerProfile(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPartnerProfile/UpdatePartnerProfile', data, messageService);
    }
}
